import { render, staticRenderFns } from "./editResponsibilities.vue?vue&type=template&id=63aff0c2&"
import script from "./editResponsibilities.vue?vue&type=script&lang=js&"
export * from "./editResponsibilities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports